import { render, staticRenderFns } from "./LocalMenu.vue?vue&type=template&id=481e41a2&scoped=true&"
import script from "./LocalMenu.vue?vue&type=script&lang=js&"
export * from "./LocalMenu.vue?vue&type=script&lang=js&"
import style0 from "./LocalMenu.vue?vue&type=style&index=0&id=481e41a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e41a2",
  null
  
)

export default component.exports